var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tlbs-map',{ref:"mapRef",attrs:{"api-key":"XAUBZ-QGZC7-DCBXR-PDQ7T-MD4P7-7HBJ2","center":_vm.center,"zoom":_vm.zoom,"control":_vm.control},on:{"click":_vm.onClick,"map_inited":_vm.onMapInited}},[_c('div',{staticClass:"control-container"},[_c('button',{on:{"click":function($event){$event.stopPropagation();return _vm.switchInfoWindow.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.visible ? '关闭' : '开启')+"窗口 ")])]),_c('tlbs-info-window',{ref:"infoWindowRef",attrs:{"visible":_vm.visible,"position":_vm.center,"content":_vm.address,"options":{
    offset: {
      x: 0,
      y: 0,
    }
  }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }